/**
 * URL からクエリパラメータ・フラグメントを切り落とす。
 * 「?」と「#」のうち最初に現れた位置から後ろをすべて削除する（X の「リンクをコピー」で付く `?s=20` など）。
 * 前後の空白は保持する（トリムは検証側で行う）。
 */
export const stripUrlParams = (value: string): string => {
  const index = value.search(/[?#]/)
  return index === -1 ? value : value.slice(0, index)
}
